import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import Modal from 'react-modal';
import { validateFloat } from "../../helpers/common";
import CustomScrollMenu from "../customScrollMenu"



const Stipend = ({ getStipendsDetails, updateStipendList, selectedStipends, editMode, removeStipends, stipends }) => {
    const navigate = useNavigate();
   
 const params = useParams();
    const contract_id = params.contract_id;
    const [isBtn, setIsBtn] = useState(false);
    const [stipend, setStipend] = useState(null);
    const [stipendTags, setStipendTags] = useState(null);
    const [tags, setTags] = useState(null);
    const [currentTag, setCurrentTag] = useState(null);

    const [addStipendModalOpen, setAddStipendModalOpen] = useState(null);



    const Arrow = ({ text, className }) => {
        return (<div className={className}  >{text}</div>);
    };

    const ArrowLeft = Arrow({ text: '<<', className: 'arrow-prev' });
    const ArrowRight = Arrow({ text: '>>', className: 'arrow-next' });


    useEffect(() => {

        window.scrollTo(0, 0)

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }

        getStipendTags();


    }, []);


    const getStipendTags = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-stipend-tags/", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {



                const tags = response.data?.stipend_tags?.map(el => {
                    const { tag_title, stipend_tag_id } = el;

                    return (<div className={`btn btn-grey`} key={stipend_tag_id}  >{tag_title}</div>)
                });

                setStipendTags(tags);
                setTags(response.data?.stipend_tags);


            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Request Stipend Tags Not Found", text: error.message });

            });
    }


    const saveStipend = async (e) => {
        e.preventDefault();
        setIsBtn(true);

        if (!stipend?.stipend_amount || !stipend.stipend_tag_id) {
            Swal.fire({ icon: "error", title: "Error", text: "All fields are required." });
            setIsBtn(false)
        }
        else if (!validateFloat(stipend?.stipend_amount)) {
            Swal.fire({ icon: "error", title: "Error", text: "Enter a numeric bonus Value." });
            setIsBtn(false)

        }
        else {

            await axios.post(process.env.REACT_APP_API_URL + "/save-stipend-by-id", {
                stipend_amount: stipend.stipend_amount,
                stipend_tag_id: stipend.stipend_tag_id,
                contract_id:contract_id,

            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setAddStipendModalOpen(false);
                        getStipendsDetails();
                        updateStipendList();

                    }
                    else {
                        Swal.fire({ icon: "error", title: "Error", text: response?.data?.message });
                    }

                    setIsBtn(false)
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };





    return (
        <>
            {editMode ? 
        <>
           {selectedStipends?.length>0 && <button onClick={() => {  removeStipends(1)  }} className="btn btn-lg btn-under bg-none">Remove ({selectedStipends?.length})</button> }
            <button onClick={() => { removeStipends() }} className="btn btn-lg  btn-under">Remove All</button>

            </>
            :
             <>
             { (!stipends || stipends?.length < 5) &&
          
            <button onClick={() => { setStipend(null); setAddStipendModalOpen(true) }} className="btn btn-secondary list-button-add color-white flex-grow-1">

                <label>Add</label>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                        <path d="M8.75 9.75V14.25H10.25V9.75H14.75V8.25H10.25V3.75H8.75V8.25H4.25V9.75H8.75Z" fill="white" />
                    </svg>
                </span>
            </button>
}
</>
}
            <Modal
                isOpen={addStipendModalOpen}
                onRequestClose={() => { setAddStipendModalOpen(false) }}
                contentLabel="Add Weekly Stipend"
                className="modal"
                overlayClassName="overlay"
            >
                <div className="modal-title" >

                    <div className="flex-equal justify-content-start " ></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica  color-white">Add Weekly Stipend</h3>
                    <div className="flex-equal justify-content-end" >
                        <div className="icon" onClick={() => setAddStipendModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
                <form onSubmit={saveStipend} action="#"  >

                <div className="modal-body min-height" >
                    <div className="box modal" >
                        <div className="form-content" >
                            <div className="input-container" >
                               <input type="text" className="transparent-input" id="stipend" placeholder="$0"
                                    name="stipend_amount" value={stipend?.stipend_amount > 0 ? "$" + stipend?.stipend_amount : ""}
                                    onChange={(e) => setStipend({ ...stipend, stipend_amount: e.target.value?.replace("$", "") })}
                                />
                            </div>
                            {stipend?.stipend_tag_id > 0 &&
                                <div className="input-container align-items-center" >



                                    <button className="btn btn-primary" >
                                        {currentTag["tag_title"]}</button>

                                </div>
                            }

  <div className="input-container align-items-center color-light text-center fs-18" >

                                   Note: Please make sure you <br/> enter the weekly stipend.

                                </div>




                        </div>




                    </div>

                     <div className="px-2 horizontal-bottom-menu" >

 <CustomScrollMenu
    items={tags}
    selectedId={stipend?.stipend_tag_id}
    id="stipend_tag_id"
    onSelect={(key) => {
        setStipend({ ...stipend, stipend_tag_id: key });
        const t = tags?.find((o) => o.stipend_tag_id === key);
        setCurrentTag(t);
    }}
/>

                       
                    </div>


                   </div>
                    <div className="modal-footer  justify-content-space-between" >
                        <button className="btn btn-secondary" type="button" onClick={() => { setAddStipendModalOpen(false) }}>Cancel</button>
                        <button className=" btn btn-primary" type="submit" disabled={isBtn  || !stipend?.stipend_amount || !stipend.stipend_tag_id}>
                            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>


                    </div>

                </form>
            </Modal>

        </>
    );
};

export default Stipend;